import { Injectable } from '@angular/core';
import {RouteLibraryService} from '../route/route-library.service';
import {AuthorizationService} from '../authorization/authorization.service';
import {UserModel} from './user-list/user.model';
import {RouteLibraryEntities} from '../route/route-library-entity';

@Injectable({
  providedIn: 'root'
})
export class UserLinkService {

  constructor(
    private routeLibraryService: RouteLibraryService,
    private authorizationService: AuthorizationService,
  ) { }

  public getLink(user: UserModel): string {
    const loggedInUserCalculatedRoleInstant = this.authorizationService.getLoggedInUserCalculatedRoleInstant();
    if (!loggedInUserCalculatedRoleInstant) {
      return '';
    }
    if (AuthorizationService.userCalculatedRoleHasRightsMoreThan(user, loggedInUserCalculatedRoleInstant)) {
      return '';
    }
    return this.routeLibraryService.getRoute({
      entity: RouteLibraryEntities.USER,
      action: 'view',
      id: user.id
    });
  }
}
